import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { defaultBody } from "src/pages/Configuration/CollegiateBody/utils/form_data";

const actionType = {
  SetCollegiateBodyList: '[COLLEGIATE_BODY] SET_COLLEGIATE_BODY_LIST',
  SetSelectedBody: '[COLLEGIATE_BODY] SET_SELECTED_BODY',
};

const initialState = {
  bodyList: [],
  selectedBody: defaultBody
};

export const reducer = persistReducer(
  { storage, key: 'collegiate_body', whitelist: [] },
  (state = initialState, action) => {
    switch (action.type) {
      case actionType.SetCollegiateBodyList:
        return { ...state, bodyList: action.payload }
      
      case actionType.SetSelectedBody:
        return { ...state, selectedBody: action.payload }
      
      default:
        return state
    }
  }
)

export const setBodyList = data => ({ type: actionType.SetCollegiateBodyList, payload: data })

export const setSelectedBody = data => ({ type: actionType.SetSelectedBody, payload: data })